import makeRequest from "../api/makeRequest";
import { RequstMethods } from "../api/requestMethode";
import url from "../api/urls";

export default class MockService {
    static async checkEmailLogin(email: string) {
        return await makeRequest(url.mock.checkEmailLogin, RequstMethods.POST, { email });
    }

    static async mockEmailVerify(email: string, otp: string) {
        return await makeRequest(url.mock.mockEmailVerify, RequstMethods.POST, { email, otp });
    }

    static async getMockProfile() {
        return await makeRequest(url.mock.getMockProfile, RequstMethods.GET);
    }

    static async mockProfileUpdate(profileData: any) {
        return await makeRequest(url.mock.mockProfileUpdate, RequstMethods.POST, profileData);
    }

    static async getMockExam() {
        return await makeRequest(url.mock.getMockExam, RequstMethods.GET);
    }

    static async startExamByExamId(examId: string) {
        return await makeRequest(url.mock.startExamByExamId + "/" + examId, RequstMethods.POST);
    }

}